import type { PlayerTrackPosition } from '@multirx/shared/types/track.js';

/** Avance une case sur le tracé principal (boucle présentation, hors règles de course). */
export function advanceDemoPathIndex(current: number, steps: number, pathLen: number): number {
  if (pathLen <= 0) return 0;
  const s = Math.max(0, Math.floor(steps));
  return (((current + s) % pathLen) + pathLen) % pathLen;
}

/**
 * Indices successifs case par case (pour animer chaque case, pas un saut A→A+n).
 */
export function demoStepIndices(from: number, steps: number, pathLen: number): number[] {
  const n = Math.max(0, Math.floor(steps));
  if (n === 0 || pathLen <= 0) return [];
  const out: number[] = [];
  let cur = from;
  for (let i = 0; i < n; i++) {
    cur = advanceDemoPathIndex(cur, 1, pathLen);
    out.push(cur);
  }
  return out;
}

export function nextActivePlayer(current: number, playerCount: number): number {
  if (playerCount <= 0) return 0;
  return (current + 1) % playerCount;
}

export function demoPositionAt(pathIndex: number): PlayerTrackPosition {
  return {
    mainPathIndex: pathIndex,
    jokerBranchIndex: null,
    startLaneIndex: null,
  };
}

/** Pas de lancer 1–6 pour la démo (présentation uniquement). */
export function pickDemoMoveSteps(rng: () => number = Math.random): number {
  return 1 + Math.floor(rng() * 6);
}

/** Pioche un circuit jouable au hasard, en évitant le précédent si possible. */
export function pickDemoCircuit<T extends { id: number; circuit?: { path?: unknown[] } | null }>(
  circuits: readonly T[],
  previousId: number | null = null,
  minPathLen = 12,
  rng: () => number = Math.random
): T | null {
  const eligible = circuits.filter((c) => (c.circuit?.path?.length ?? 0) >= minPathLen);
  if (eligible.length === 0) return null;
  if (eligible.length === 1) return eligible[0];
  const pool = previousId == null ? eligible : eligible.filter((c) => c.id !== previousId);
  const list = pool.length > 0 ? pool : eligible;
  return list[Math.floor(rng() * list.length)];
}
